import { CommonModule } from "@angular/common";
import {
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NxIconModule } from "@aposin/ng-aquila/icon";
import { TranslateModule } from "@ngx-translate/core";
import { AuthSessionFacade } from "@services/auth-session/auth-session.facade";
import { CrossAppNavigationService } from "@services/cross-app-navigation/cross-app-navigation.service";
import { NotificationFacade } from "@services/notification/notification.facade";
import { InfiniteScrollDirective } from "ngx-infinite-scroll";

@Component({
  selector: "app-notification-sidebar",
  standalone: true,
  imports: [
    CommonModule,
    NxIconModule,
    InfiniteScrollDirective,
    TranslateModule,
  ],
  templateUrl: "./notification-sidebar.component.html",
  styleUrls: ["./notification-sidebar.component.scss"],
})
export class NotificationSidebarComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  @Output() public toggledNotification = new EventEmitter<boolean>();

  protected unreadNotification$ = this.notificationFacade.unreadCount$;

  private asOfDate: string;
  public isLoading: boolean = true;
  private notificationFlag: boolean;
  private totalPages: number = 0;
  private userId: string;

  protected messages: any = [];
  private readonly data = {
    page: 0,
    size: 10,
  };
  public throttle = 680;
  public scrollDistance = 2;
  private readonly direction = "";
  public isEmptyNotifiList: boolean = false;
  public scrolledDown: boolean = false;

  constructor(
    private readonly authSessionFacade: AuthSessionFacade,
    private readonly notificationFacade: NotificationFacade,
    private readonly elementRef: ElementRef,
    private readonly crossAppNavigationService: CrossAppNavigationService,
  ) {}

  ngOnInit() {
    this.userId = this.authSessionFacade.userSnapshot?.userId ?? "";
    if (!this.userId) {
      this.authSessionFacade.user$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((user) => {
          if (!this.userId && user?.userId) {
            this.userId = user.userId;
            this.getNotificationList();
          }
        });
    } else {
      this.getNotificationList();
    }

    this.notificationFacade.messages$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((messages: any[]) => {
        this.messages = messages;
      });
  }

  private getNotificationList() {
    if (!this.userId) {
      return;
    }

    this.notificationFlag = true;
    this.notificationFacade
      .loadFirstPage(this.userId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notificationList: any) => {
        if (notificationList?.messages?.length > 0) {
          this.asOfDate = notificationList.asOfDate;
          this.totalPages = notificationList.totalPages;
          this.isLoading = this.totalPages <= 1 ? false : true;
          this.notificationFlag = false;
        } else {
          this.isLoading = false;
          this.notificationFlag = true;
          this.isEmptyNotifiList = true;
        }
      });
  }

  protected notifClicked(_notification: any) {
    // this.store.dispatch(new SEND_READ_NOTIFICATION(payload)).subscribe((state) => {
    //   const redirectPayload = {
    //     operator: this.userId,
    //     action: ACTIONS.NOTIFICATION,
    //     notificationId: notification.id
    //   }
    this.crossAppNavigationService
      .resolveSatSwitchSite("NOTIFICATION_SYS_URL")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    // });
  }

  protected getClass(seen: any) {
    if (seen) {
      return "notification-read";
    } else {
      return "notification";
    }
  }

  protected getIcon(notification: any) {
    if (notification.linkType == "DOC") {
      if (notification.seenInd) {
        return "download-active";
      } else {
        return "download-inactive";
      }
    } else if (
      notification.messageCategory === "CLAIMS_MSG" ||
      notification.messageCategory === "RENEWAL_MSG" ||
      notification.messageCategory === "POLICY_MSG"
    ) {
      return "icon-status";
    } else {
      return "icon-notif";
    }
  }

  protected toCamelCase(string: string): string {
    let formattedString = "";
    const stringArr = string.split(" ");
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < stringArr.length; i++) {
      if (i > 0) {
        formattedString = formattedString.concat(" ");
      }
      formattedString = formattedString.concat(
        stringArr[i].charAt(0).toUpperCase() +
          stringArr[i].substr(1).toLowerCase(),
      );
    }
    return formattedString;
  }

  @HostListener("document:click", ["$event"])
  protected clickout(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.toggledNotification.emit(false);
      this.elementRef.nativeElement.ownerDocument.body.style.position = null;
      this.elementRef.nativeElement.ownerDocument.body.style.overflow = null;
    }
  }

  protected onScrollDown(_ev) {
    //   this.scrolledDown = true;
    //   if (!this.notificationFlag) {
    //     this.data = {
    //       page: this.data.page + 1,
    //       size: this.data.size,
    //     }
    //     if (this.data.page < this.totalPages) {
    //       this.data['dateFrom'] = this.asOfDate;
    //       this.getNotificationList(this.data);
    //     } else {
    //       this.isLoading = false;
    //     }
    //   }
  }

  ngOnDestroy() {
    // ensure any scroll-lock is removed if the component is destroyed
    try {
      this.elementRef.nativeElement.ownerDocument.body.style.overflow = null;
      this.elementRef.nativeElement.ownerDocument.body.style.position = null;
    } catch (e) {
      // ignore
    }
  }
}
